/* VOROG — LE SOUFFLE.

   CINQUIEME FORME, ET LA SEULE QUI NE DESSINE RIEN. Une croix, une trainee,
   des cadres, un circuit : quatre objets POSES par-dessus la page, quatre
   refus. Le defaut leur etait commun — ils ajoutaient une forme la ou il
   fallait modifier ce qui est deja la.

   Ici il n'y a aucune forme. Une lentille invisible suit la main et deforme
   tres legerement ce qu'elle survole : le fond, la trame, une photo, un titre.
   Rien n'est peint, rien n'a de couleur, rien ne se superpose.

   LA FORME VIENT DU GESTE, PAS D'UNE IMAGE-CLE. C'est ce qui la rend
   organique. La lentille s'etire dans la direction du mouvement et se
   comprime dans l'autre — a surface constante, comme une goutte — puis
   revient au rond quand la main s'arrete. Aucune animation n'est ecrite : la
   deformation EST la vitesse. Une choregraphie en boucle se serait vue au
   deuxieme passage ; celle-ci ne se repete jamais parce qu'aucun geste ne se
   repete.

   CE QUE CA COUTE.
   - UN element, UNE ecriture de transform par frame. Rien d'autre.
   - La boucle s'arrete des que la lentille a rattrape la main ET repris sa
     forme ronde : souris immobile, plus une seule frame.
   - `backdrop-filter` travaille sur une region de 170 px de cote, sur le GPU.
     Sans support, la ligne est ignoree et il ne reste rien — aucun repli a
     ecrire, aucune verification a faire.
   - Souris fine uniquement, jamais en mouvement reduit, et RIEN sur telephone :
     le fichier sort a la premiere ligne, il ne pose pas un ecouteur. */
(function () {
  var mm = window.matchMedia;
  if (!mm) return;
  if (!mm('(hover: hover) and (pointer: fine)').matches) return;
  if (mm('(prefers-reduced-motion: reduce)').matches) return;

  var SUIVI = 0.16;    // rattrapage de la lentille, par frame
  var LISSE = 0.22;    // lissage de la vitesse
  var ETIRE = 0.055;   // combien un pixel par frame etire la goutte
  var MAXI = 0.85;     // etirement maximal

  var de = document.documentElement;
  var el = null, sat = null;
  var x = 0, y = 0, lx = 0, ly = 0, vx = 0, vy = 0;
  var sx2 = 0, sy2 = 0;
  var vu = false, tourne = false;

  function creuse() {
    el = document.createElement('div');
    el.className = 'vk-souffle';
    el.setAttribute('aria-hidden', 'true');
    document.body.appendChild(el);
    // Le satellite : un mini-cadre qui traîne un peu derrière le curseur.
    // Sa rotation est en CSS pur (compositor) — le JS ne fait que le porter.
    sat = document.createElement('div');
    sat.className = 'vk-sat';
    sat.setAttribute('aria-hidden', 'true');
    sat.innerHTML = '<i></i>';
    document.body.appendChild(sat);
    lx = x; ly = y; sx2 = x; sy2 = y;
  }

  function boucle() {
    var dx = x - lx, dy = y - ly;
    lx += dx * SUIVI;
    ly += dy * SUIVI;

    // La vitesse est lissee : sans ca, la moindre saccade du pointeur ferait
    // claquer la goutte d'une forme a l'autre.
    vx += (dx - vx) * LISSE;
    vy += (dy - vy) * LISSE;

    var v = Math.sqrt(vx * vx + vy * vy);
    var e = Math.min(v * ETIRE, MAXI);
    var a = v > 0.4 ? Math.atan2(vy, vx) : 0;

    // Surface constante : ce qu'on gagne en longueur, on le perd en largeur.
    // C'est la difference entre une goutte et un ballon qui gonfle.
    var sx = 1 + e, sy = 1 / (1 + e);

    el.style.transform =
      'translate3d(' + lx.toFixed(1) + 'px,' + ly.toFixed(1) + 'px,0)' +
      ' rotate(' + a.toFixed(3) + 'rad)' +
      ' scale(' + sx.toFixed(3) + ',' + sy.toFixed(3) + ')';

    // La grille ne bouge pas, c'est la fenetre qui bouge : la phase du motif
    // est recalee a l'inverse du deplacement (modulo 22 px, le pas de la
    // trame du site). Sans ca, les pixels voyageraient colles au curseur —
    // un objet rapporte de plus. La marge du bloc fait 95 px (-9.5rem).
    el.style.backgroundPosition =
      (((95 - lx) % 22 + 22) % 22).toFixed(1) + 'px ' +
      (((95 - ly) % 22 + 22) % 22).toFixed(1) + 'px';

    // Le satellite suit avec SON retard (0,09 contre 0,16) : il arrive
    // toujours apres la lentille, decale de 22 px sous la diagonale — c'est
    // ce petit ecart qui le fait exister comme objet, pas comme doublon.
    sx2 += (x + 22 - sx2) * 0.09;
    sy2 += (y + 26 - sy2) * 0.09;
    sat.style.transform = 'translate3d(' + sx2.toFixed(1) + 'px,' + sy2.toFixed(1) + 'px,0)';

    // On rend la main quand la lentille a rattrape la main ET repris sa forme.
    if (Math.abs(dx) < 0.4 && Math.abs(dy) < 0.4 && e < 0.01 &&
        Math.abs(x + 22 - sx2) < 0.5 && Math.abs(y + 26 - sy2) < 0.5) { tourne = false; return; }
    requestAnimationFrame(boucle);
  }

  document.addEventListener('pointermove', function (e2) {
    if (e2.pointerType && e2.pointerType !== 'mouse') return;
    x = e2.clientX;
    y = e2.clientY;
    if (!vu) { vu = true; creuse(); de.classList.add('vk-souris'); }
    if (!tourne) { tourne = true; requestAnimationFrame(boucle); }
  }, { passive: true });

  document.addEventListener('pointerleave', function () { de.classList.remove('vk-souris'); });
  document.addEventListener('pointerenter', function () { if (vu) de.classList.add('vk-souris'); });

  /* L'ECLAT DU CLIC. Un seul element, reutilise a chaque coup : le cadre
     carre du site (le meme motif que le hero) part du point de contact,
     tourne d'un quart et s'evanouit en 400 ms. Le detour par offsetWidth
     relance l'animation CSS — c'est elle qui fait tout, pas une boucle. */
  var eclat = null;
  document.addEventListener('pointerdown', function (e3) {
    if (e3.pointerType && e3.pointerType !== 'mouse') return;
    if (!eclat) {
      eclat = document.createElement('div');
      eclat.className = 'vk-clic';
      eclat.setAttribute('aria-hidden', 'true');
      document.body.appendChild(eclat);
    }
    eclat.style.left = e3.clientX + 'px';
    eclat.style.top = e3.clientY + 'px';
    eclat.classList.remove('vk-clic--va');
    void eclat.offsetWidth;
    eclat.classList.add('vk-clic--va');
  }, { passive: true });
})();
